import React, { useEffect, useState } from "react";
import img from './ll.png'
export default function Purchase() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true); 
  }, []);

  return (
    <>
   
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg w-full max-w-md overflow-hidden relative"
            onClick={(e) => e.stopPropagation()} 
          >

            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>


 <div className="p-8 text-center bg-white shadow-md rounded-lg max-w-md mx-auto">
  <img
    src={img}
    alt="Company Logo"
    className="mx-auto h-20 mb-4"
  />
  <h2 className="text-xl font-bold text-gray-800 mb-4">
    Purchase Your Course
  </h2>
  <p className="text-gray-600 mb-6">
    Get access to premium digital learning classes and start your journey today!
  </p>

  <form className="space-y-4">
    <div className="text-left">
      <label className="block text-gray-700 font-medium mb-1">Full Name</label>
      <input
        type="text"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Enter your full name"
      />
    </div>

    <div className="text-left">
      <label className="block text-gray-700 font-medium mb-1">Email</label>
      <input
        type="email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Enter your email"
      />
    </div>

    
    <button className="w-full bg-[#19818C] text-white font-base py-2 rounded-md hover:bg-blue-500 transition">
      continue
    </button>
  </form>
</div>


          </div>
        </div>
      )}
    </>
  );
}
